import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Loader } from "@/components/Loader";
import { StatusChip } from "@/components/StatusChip";
import { Lock, ClipboardList } from "lucide-react";

export default function Library() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/nurse/library").then((r) => setData(r.data)).catch((e) => toast.error(apiError(e)));
  }, []);

  if (!data) return <Loader />;

  return (
    <div className="space-y-4" data-testid="nurse-library">
      <h1 className="text-[24px] font-bold text-[#1c1b1b]">Training Library</h1>
      {data.access_status !== "approved" && (
        <p className="text-sm text-[#434654] bg-white border border-[#E5E7EB] rounded-lg p-4">
          Modules stay locked until MITRA approves your access request.
        </p>
      )}
      <div className="space-y-3">
        {data.modules.length === 0 && (
          <p className="text-sm text-[#434654]" data-testid="library-empty">No modules available yet.</p>
        )}
        {data.modules.map((m) => {
          const locked = !m.assigned;
          return (
            <button
              key={m.id}
              data-testid={`library-module-${m.id}`}
              disabled={locked}
              onClick={() => !locked && navigate(`/app/modules/${m.id}`)}
              className={`w-full text-left bg-white rounded-lg border border-[#E5E7EB] p-4 flex items-center gap-3 transition-colors ${
                locked ? "opacity-70 cursor-not-allowed" : "hover:border-[#003d9b]"
              }`}
            >
              <div className="w-10 h-10 rounded-lg bg-[#003d9b]/10 flex items-center justify-center shrink-0">
                {locked ? <Lock className="w-5 h-5 text-[#9CA3AF]" /> : <ClipboardList className="w-5 h-5 text-[#003d9b]" />}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-[#1c1b1b] truncate">{m.title}</p>
                <p className="text-xs text-[#434654] line-clamp-1">{m.description || `${m.estimated_minutes} min`}</p>
              </div>
              <StatusChip status={locked ? "locked" : m.status} />
            </button>
          );
        })}
      </div>
    </div>
  );
}
